import React from "react"

interface FormattedTranslationProps {
  html: string
  className?: string
}

const FormattedTranslation = ({
  html,
  className = "",
}: FormattedTranslationProps): JSX.Element | null => {
  if (!html) return null

  return (
    <span className={className} dangerouslySetInnerHTML={{ __html: html }} />
  )
}

export default FormattedTranslation
